import i18n from "../i18n";
import store from "../store";
import { Notification } from "element-ui";
import actions from "../store/shardActions";
import { isEmpty } from "./utils";
import { clearLocalStorage } from "./lsClear";
function errorResponseHandler(res) {
  console.log(res);

  //  不处理 响应

  let nohandleCode = ["A0442"];

  // 未登录获取配置 特殊处理，C0102 提示无权限 不跳转
  let specialHandlingUrl = [
    "/v2/configs/system/wechatSwitch",
    "/v2/i18n",
    "/v2/configs/system/systemI18n",
  ];
  if (res && res.status) {
    Notification.closeAll();
    let messageCon = "";
    if (res.status >= 400 && res.status < 500) {
      // 根据不同响应来处理问题

      // 不处理code
      if (nohandleCode.includes(res.data.resultCode)) {
        return;
      }

      /** 当前token 过期   提示之后 直接退出*/
      if (res.status == 400 && res.data.resultCode == "C0105") {
        messageCon = i18n.t("errorPromptMessage.invalidToken");
        window.setTimeout(() => {
          actions.setGlobalState({
            logout: true,
          });
        }, 0);
      }
      if (res.status == 401 && res.data.resultCode == "C0102") {
        if (res.config.url && specialHandlingUrl.includes(res.config.url)) {
          messageCon = i18n.t("httpResponseErrorPromptMessage.noPermission");
        } else {
          messageCon = i18n.t("httpResponseErrorPromptMessage.invalidToken");
          store.replaceState();
          actions.setGlobalState({
            accessToken: "",
            //commonData修改
            dataUpdate: false,
            // 当前用户信息
            currentUser: "",
            // 当前用户权限树
            permissionTree: "",
            // 获取token报错
            getTokenError: false,
            //当前客户
            currentCustomer: "",
            //当前门店
            currentStore: "",
            //控制菜单  隐藏显示
            showMenu: true,
            // 公共客户门店数据
            commonData: {},
            // 当前应用名称
            currentAppName: "",
          });

          clearLocalStorage();

          // 重定向至登录页面
          let currentUrl = window.location.href;
          let position = currentUrl.indexOf("/#");
          let loginUrl = currentUrl.substring(0, position);
          window.location.href = loginUrl;
        }
      }
      // 当前 google登录未强制绑定
      else if (
        res.status == 401 &&
        res.data.resultCode == "A0301" &&
        res.config.url == "/v2/users/work-bench"
      ) {
        actions.setGlobalState({
          logout: true,
        });
      } else {
        messageCon = i18n.t("httpResponsePromptMessage." + res.data.resultCode);
      }
    } else if (res.status >= 500) {
      // 服务器端问题
      messageCon = i18n.t("httpResponseErrorPromptMessage.>500");
    }
    if (!isEmpty(messageCon)) {
      Notification.error({
        showClose: true,
        message: messageCon,
      });
    }
  }
}

export default errorResponseHandler;
